import React from 'react';

import { useLocale } from '@adsk/alloy-react-locale';
import ProgressRing from '@adsk/alloy-react-progress-ring';
import theme from '@adsk/alloy-react-theme';

const EntityPickerModalLoadMoreLoader = () => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
  return (
    <div
      css={[
        {
          display: 'flex',
          alignItems: 'center',
          height: 68,
          paddingLeft: 50,
        },
      ]}
    >
      <ProgressRing
        size={ProgressRing.SIZES.SMALL}
        style={{ margin: '5px 0' }}
      />
      <span
        css={[
          theme.typography.bodySmall,
          {
            marginLeft: 13,
            color: theme.colors.charcoal700,
          },
        ]}
      >
        {T.translate('LOADING_MORE_RESULTS')}
      </span>
    </div>
  );
};

export default EntityPickerModalLoadMoreLoader;
